module.exports = __webpack_public_path__ + "img/home-photo-frame.12e3df86.svg";